__turbopack_context__.v({
  "grid": "sVUyba_grid",
  "iconImage": "sVUyba_iconImage",
  "iconWrapper": "sVUyba_iconWrapper",
  "inner": "sVUyba_inner",
  "item": "sVUyba_item",
  "itemCaption": "sVUyba_itemCaption",
  "itemTitle": "sVUyba_itemTitle",
  "section": "sVUyba_section",
  "textStack": "sVUyba_textStack",
  "title": "sVUyba_title",
});
